export const defaultLanguage = 'मराठी';

export const supportedLanguages = Object.freeze({
    हिन्दी: 'hi-IN',
    मराठी: 'mr-IN',
    ENGLISH_UK: 'en-GB',
    ENGLISH_US: 'en-US',
});
